import {useInjex} from '@injex/react-plugin';
import AccountsMetaDataManager from '../managers/AccountsMetaDataManager.mdl';

export default function useAccountsMetaDataManager(): AccountsMetaDataManager {
    const [inject] = useInjex();
    return inject<AccountsMetaDataManager>('accountsMetaDataManager');
}
